import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const money = (n) =>
  new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 0 }).format(Number(n) || 0) + " ₺";

export const num = (n) =>
  new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 1 }).format(Number(n) || 0);

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const trDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};

export const api = {
  get: (path) => axios.get(`${API}${path}`).then((r) => r.data),
  post: (path, body) => axios.post(`${API}${path}`, body).then((r) => r.data),
  patch: (path, body) => axios.patch(`${API}${path}`, body).then((r) => r.data),
  del: (path) => axios.delete(`${API}${path}`).then((r) => r.data),
};
